import { cn } from '../lib/cn'

interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  as?: React.ElementType
  className?: string
}

export function Section({ as: Component = 'section', className, ...props }: SectionProps) {
  return (
    <Component
      className={cn(
        'py-10 sm:py-14 lg:py-20 lg:snap-center',
        className
      )}
      {...props}
    />
  )
}
